import React, { FC }                 from "react";
import { useDispatch, useSelector }  from "react-redux";
import { Table }                     from "semantic-ui-react";
import GetCustomersSort              from "../../../application/usecase/customer/GetCustomersSort";
import CustomerSearchValue           from "../../../domain/customer/criteria/CustomerSearchValue";
import CustomerSortType              from "../../../domain/customer/criteria/CustomerSortType";
import Customers                     from "../../../domain/customer/Customers";
import CurrentPage                   from "../../../domain/fundamentals/pagination/CurrentPage";
import { ResKaState }                from "../../../index";
import BottomSection                 from "../common/layout/BottomSection";
import ListTotalCount                from "../common/layout/ListTotalCount";
import CustomerDeleteButton          from "./CustomerDeleteButton";
import CustomerEditButton            from "./CustomerEditButton";
import CustomerNextReservationButton from "./CustomerNextReservationButton";
import CustomerRecordCountLabel      from "./CustomerRecordCountLabel";
import CustomersPagination           from "./CustomersPagination";

const CustomerList: FC = () => {
  const customers: Customers = useSelector((state: ResKaState) => state.customers);
  const getCustomersSort: GetCustomersSort = new GetCustomersSort(useDispatch());
  const current: CurrentPage = customers.pagination.current;
  const search: CustomerSearchValue = customers.search;

  if (customers.isEmpty() && customers.search.value) {
    return (
      <p>検索結果がありません。</p>
    )
  }

  if (customers.isEmpty()) {
    return (
      <p>顧客がまだ作成されていません。</p>
    );
  }

  return (
    <>
      <ListTotalCount>{ customers.count.toString() }</ListTotalCount>
      <Table
        striped
        sortable
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              sorted={ customers.sortType === CustomerSortType.NUMBER_ASC ? "ascending" : customers.sortType === CustomerSortType.NUMBER_DESC ? "descending" : undefined }
              onClick={ () => customers.sortType === CustomerSortType.NUMBER_ASC ? getCustomersSort.execute(current, search, CustomerSortType.NUMBER_DESC) : getCustomersSort.execute(current, search, CustomerSortType.NUMBER_ASC) }
            >
              顧客番号
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={ customers.sortType === CustomerSortType.NAME_ASC ? "ascending" : customers.sortType === CustomerSortType.NAME_DESC ? "descending" : undefined }
              onClick={ () => customers.sortType === CustomerSortType.NAME_ASC ? getCustomersSort.execute(current, search, CustomerSortType.NAME_DESC) : getCustomersSort.execute(current, search, CustomerSortType.NAME_ASC) }
            >
              顧客氏名
            </Table.HeaderCell>
            <Table.HeaderCell>
              管理メニュー
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={ customers.sortType === CustomerSortType.CREATED_ASC ? "ascending" : customers.sortType === CustomerSortType.CREATED_DESC ? "descending" : undefined }
              onClick={ () => customers.sortType === CustomerSortType.CREATED_ASC ? getCustomersSort.execute(current, search, CustomerSortType.CREATED_DESC) : getCustomersSort.execute(current, search, CustomerSortType.CREATED_ASC) }
            >
              作成日
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={ customers.sortType === CustomerSortType.UPDATED_ASC ? "ascending" : customers.sortType === CustomerSortType.UPDATED_DESC ? "descending" : undefined }
              onClick={ () => customers.sortType === CustomerSortType.UPDATED_ASC ? getCustomersSort.execute(current, search, CustomerSortType.UPDATED_DESC) : getCustomersSort.execute(current, search, CustomerSortType.UPDATED_ASC) }
            >
              更新日
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            customers.toList().map(customer => (
              <Table.Row>
                <Table.Cell>
                  { customer.detail.number.value }
                </Table.Cell>
                <Table.Cell>
                  { `${ customer.detail.name.lastName.value } ${ customer.detail.name.firstName.value }` }
                  &nbsp;&nbsp;&nbsp;
                  <CustomerRecordCountLabel customer={ customer }/>
                </Table.Cell>
                <Table.Cell>
                  <CustomerNextReservationButton customer={ customer }/>
                  <CustomerEditButton customer={ customer }/>
                  <CustomerDeleteButton customer={ customer }/>
                </Table.Cell>
                <Table.Cell>
                  { customer.trail.createdAt.toString() }
                </Table.Cell>
                <Table.Cell>
                  { customer.trail.updatedAt.toString() }
                </Table.Cell>
              </Table.Row>
            ))
          }
        </Table.Body>
      </Table>

      <BottomSection>
        <CustomersPagination/>
      </BottomSection>
    </>
  );
};

export default CustomerList;
